import { WPSimpleArticle } from 'types/articles';
import { useApiRequest } from './useApiRequest';

type UsePosts = {
  readonly search?: string;
  readonly slug?: string;
  readonly id?: string;
  readonly revision?: string;
  readonly categories?: number[];
  readonly category_name?: string;
  readonly per_page?: number;
  readonly skip?: boolean;
  readonly preview?: string;
};

const endpoint = 'posts';

export const usePosts = <T extends WPSimpleArticle>(options?: UsePosts) => {
  const { slug, skip, category_name, per_page, preview = false, ...restOptions } = options || {};
  return useApiRequest<T[]>({
    slug,
    skip,
    endpoint,
    ...(slug && !preview && { cacheKey: `post:${slug}` }),
    ...(category_name && { cacheKey: `posts:${category_name}${per_page ? `:${per_page}` : ''}` }),
    options: {
      ...(category_name && { category_name }),
      ...(per_page && { per_page }),
      ...restOptions,
    },
    fields: 'date,modified,type,acf,id,title,content,excerpt,yoast_meta,yoast_title,yoast_json_ld,yoast_head,slug,_embedded,_links,wpml_translations',
  });
};

export const usePostsPreview = <T extends WPSimpleArticle>(options?: UsePosts) => {
  const { slug, id, revision, skip, category_name, per_page, preview, ...restOptions } = options || {};
  return useApiRequest<T[]>({
    skip,
    endpoint: `${endpoint}/${id}/revisions/${revision}`,
    options: {
      status: 'draft',
      ...restOptions,
    },
    preview,
    embed: false,
  });
};
